/**
 * Shared Constants
 */

export const REQUEST_TIMEOUT = 10000; // 10 seconds
export const REQUEST_HEADERS = {
  "Content-Type": "application/json",
} as const;
